<div class="main-page-section default_font p-3 p-md-4 px-lg-5">
    <div class="breadcrumbs-section p-0 mb-3 mb-md-4 mb-lg-5">
        <span class="prev-page pr-1 prev"><a routerLink="/overview">Home</a></span>
        <span class="separator">&nbsp; > &nbsp;</span>
        <span class="curr-page pl-1 breadcrumbs-section-font">Create New Permit</span>
    </div>
    <div class="d-flex align-items-center justify-content-between mb-3 mb-md-4">
        <h2 class="font-weight-medium mb-3 mb-md-4">Create Work Entry Permit Request</h2>
    </div>

    <!-- form start -->
    <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
        <!-- ROOT CAUSE FIX: Removed ngb-panel + ng-template ngbPanelContent to prevent blank page issues -->
        <ngb-accordion [activeIds]="activeIds" class="form_accordion">
            <!-- Vendor Details Section -->
            <div class="mb-4 mb-md-5">
                <h5 class="mb-3 mb-md-4 font-weight-medium">Vendor Details</h5>
                <div class="row row-gap-4">
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" formControlName="name" id="name" class="form-control"
                                    placeholder="Name">
                                <label>Name</label>
                            </div>
                            <div *ngIf="myForm.get('name').invalid && myForm.get('name').touched"
                                class="small text-danger">
                                <div *ngIf="myForm.get('name').errors?.required">Name is required</div>
                                <div *ngIf="myForm.get('name').errors?.maxlength">The name may not be longer than 100
                                    charecters</div>
                            </div>
                        </div>
                    </div>
            </div>
            <!-- Work Details Section -->
            <div class="mb-4 mb-md-5 border-top border-light pt-4 pt-md-5">
                <h5 class="mb-3 mb-md-4 font-weight-medium">Work Details</h5>
                <div class="row row-gap-4 mb-4">
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <select class="form-control" formControlName="natureOfWork">
                                    <option value="1">Value 01</option>
                                    <option value="2">Value 02</option>
                                </select>
                                <label>Nature of work</label>
                            </div>
                            <div *ngIf="myForm.get('natureOfWork').invalid && myForm.get('natureOfWork').touched"
                                class="small text-danger">
                                <div *ngIf="myForm.get('natureOfWork').errors?.required">Nature of work is required
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row row-gap-4 mb-4">
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="dp-hidden position-absolute">
                                <input name="datepicker" class="form-control" ngbDatepicker container="body"
                                    #datepicker="ngbDatepicker" [autoClose]="'outside'"
                                    (dateSelect)="onDateSelection($event)" [displayMonths]="2" [dayTemplate]="t"
                                    outsideDays="hidden" [startDate]="fromDate!" tabindex="-1" />
                                <ng-template #t let-date let-focused="focused">
                                    <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                                        [class.faded]="isHovered(date) || isInside(date)"
                                        (mouseenter)="hoveredDate = date" (mouseleave)="hoveredDate = null">
                                        {{ date.day }}
                                    </span>
                                </ng-template>
                            </div>
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" class="form-control hasDatepicker" placeholder="Start Date"
                                    #dpFromDate name="dpFromDate" [value]="formatter.format(fromDate)"
                                    (input)="fromDate = validateInput(fromDate, dpFromDate.value)"
                                    (click)="datepicker.toggle()" formControlName="startDate">
                                <label>Start Date</label>
                            </div>
                            <div *ngIf="myForm.get('startDate').invalid && myForm.get('startDate').touched"
                                class="small text-danger">
                                <div *ngIf="myForm.get('startDate').errors?.required">Start date is required</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" class="form-control hasDatepicker" placeholder="End Date" #dpToDate
                                    name="dpToDate" [value]="formatter.format(toDate)"
                                    (input)="toDate = validateInput(toDate, dpToDate.value)"
                                    (click)="datepicker.toggle()" formControlName="endDate">
                                <label>End Date</label>
                            </div>
                            <div *ngIf="myForm.get('endDate').invalid && myForm.get('endDate').touched"
                                class="small text-danger">
                                <div *ngIf="myForm.get('endDate').errors?.required">End date is required</div>
                            </div>
                        </div>
                        <div class="col-12 d-flex flex-wrap row-gap-3 column-gap-4 column-gap-lg-5 column-gap-xl-6">
                            <h6 class="mb-0 w-100">Time Slot</h6>
                            <div class="custom-control custom-radio">
                                <input type="radio" id="timeSlot1" name="timeSlot" class="custom-control-input"
                                    formControlName="timeSlot">
                                <label class="custom-control-label font-weight-semibold" for="timeSlot1">Half
                                    Day</label>
                            </div>
                            <div class="custom-control custom-radio">
                                <input type="radio" id="timeSlot2" name="timeSlot" class="custom-control-input"
                                    formControlName="timeSlot">
                                <label class="custom-control-label font-weight-semibold" for="timeSlot2">Full
                                    Day</label>
                            </div>
                            <div *ngIf="myForm.get('timeSlot').invalid && myForm.get('timeSlot').touched"
                                class="small text-danger w-100">
                                <div *ngIf="myForm.get('timeSlot').errors?.required">Time slot is required</div>
                            </div>
                        </div>
                        <div class="col-12">
                            <div class="custom-control custom-checkbox">
                                <input type="checkbox" class="custom-control-input" id="weekendInclusion">
                                <label class="custom-control-label font-weight-semibold" for="weekendInclusion">Weekend
                                    Inclusion</label>
                            </div>
                        </div>
                        <div class="col-12 col-lg-10 col-xl-8 d-flex flex-column row-gap-1">
                            <h6 class="font-weight-bold">Add description of work <span
                                    class="font-weight-light">(Optional)</span></h6>
                            <div class="form-group floating_form_field mb-0 w-100">
                                <textarea class="form-control" placeholder="Description of work"></textarea>
                                <label>Description of work</label>
                            </div>
                        </div>
                    </div>
            </div>
            <!-- Supervisor Details Section -->
            <div class="mb-4 mb-md-5 border-top border-light pt-4 pt-md-5">
                <h5 class="mb-3 mb-md-4 font-weight-medium">Supervisor Details</h5>
                <div class="row row-gap-4">
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" class="form-control" placeholder="Name"
                                    formControlName="supervisorName">
                                <label>Name</label>
                            </div>
                            <div *ngIf="myForm.get('supervisorName').invalid && myForm.get('supervisorName').touched"
                                class="small text-danger w-100">
                                <div *ngIf="myForm.get('supervisorName').errors?.required">Supervisor Name is required
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" class="form-control" placeholder="Email ID"
                                    formControlName="supervisorEmail">
                                <label>Email ID</label>
                            </div>
                            <div *ngIf="myForm.get('supervisorEmail').invalid && myForm.get('supervisorEmail').touched"
                                class="small text-danger w-100">
                                <div *ngIf="myForm.get('supervisorEmail').errors?.required">Supervisor Email is required
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" class="form-control" placeholder="Phone Number"
                                    formControlName="supervisorPhone">
                                <label>Phone Number</label>
                            </div>
                            <div *ngIf="myForm.get('supervisorPhone').invalid && myForm.get('supervisorPhone').touched"
                                class="small text-danger w-100">
                                <div *ngIf="myForm.get('supervisorPhone').errors?.required">Supervisor Phone Number is
                                    required
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
            <!-- Location Details Section -->
            <div class="mb-4 mb-md-5 border-top border-light pt-4 pt-md-5">
                <h5 class="mb-3 mb-md-4 font-weight-medium">Location Details</h5>
                <div class="row row-gap-4">
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" class="form-control" placeholder="Building"
                                    formControlName="locationBuilding">
                                <label>Building</label>
                            </div>
                            <div *ngIf="myForm.get('locationBuilding').invalid && myForm.get('locationBuilding').touched"
                                class="small text-danger w-100">
                                <div *ngIf="myForm.get('locationBuilding').errors?.required">Building is required
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" class="form-control" placeholder="Floor"
                                    formControlName="locationFloor">
                                <label>Floor</label>
                            </div>
                            <div *ngIf="myForm.get('locationFloor').invalid && myForm.get('locationFloor').touched"
                                class="small text-danger w-100">
                                <div *ngIf="myForm.get('locationFloor').errors?.required">Floor is required
                                </div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6 col-lg-4 d-flex flex-column row-gap-1">
                            <div class="form-group floating_form_field mb-0 w-100">
                                <input type="text" class="form-control" placeholder="Unit"
                                    formControlName="locationUnit">
                                <label>Unit</label>
                            </div>
                            <div *ngIf="myForm.get('locationUnit').invalid && myForm.get('locationUnit').touched"
                                class="small text-danger w-100">
                                <div *ngIf="myForm.get('locationUnit').errors?.required">Unit is required
                                </div>
                            </div>
                        </div>
                    </div>
            </div>
            <!-- Worker Details Section -->
            <div class="mb-4 mb-md-5 border-top border-light pt-4 pt-md-5">
                <h5 class="mb-3 mb-md-4 font-weight-medium">Worker Details</h5>
                <div class="row row-gap-4">
                        <div class="col-12 d-flex column-gap-4">
                            <div class="d-flex floating_form_field stepperInput rounded">
                                <button type="button" class="btn btn-clear text-primary" (click)="minus()"
                                    [disabled]="workerNumber ===0?true : false">
                                    <svg-icon src="./assets/images/icons/minus.svg"></svg-icon>
                                </button>
                                <input type="text" [value]="workerNumber" class="form-control border-0">
                                <button type="button" class="btn btn-clear text-primary" (click)="plus()">
                                    <svg-icon src="./assets/images/icons/plus.svg"></svg-icon>
                                </button>
                            </div>
                            <span class="text-primary text-uppercase font-weight-bold">OR</span>
                            <div class="d-flex flex-column row-gap-1">
                                <div class="form-group floating_form_field mb-0 w-100">
                                    <input type="text" class="form-control" placeholder="Name">
                                    <label>Number of Workers</label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <h6 class="font-weight-bold mb-3 mb-md-4">Add Name and Phone Numbers <span
                                    class="font-weight-light">(Optional)</span></h6>
                            <div class="row row-gap-3 mb-3 mb-md-4" formArrayName="workersList">
                                <div class="col-12 col-md-6 col-lg-4"
                                    *ngFor="let item of workersList().controls; let i=index" [formGroupName]="i">
                                    <div class="border border-light rounded-lg p-3">
                                        <div class="d-flex justify-content-between mb-3">
                                            <h5>Worker {{i+1 | leadingZero}}</h5>
                                            <div>
                                                <a href="javascript:void(0)" class="text-primary small font-weight-bold"
                                                    (click)="clearInput(i)">Clear</a>
                                                <a href="javascript:void(0)" *ngIf="i !== 0" (click)="removeBlock(i)"
                                                    class="text-danger small font-weight-bold ml-3">Delete</a>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column row-gap-1 mb-3">
                                            <div class="form-group floating_form_field mb-0 w-100">
                                                <input type="text" class="form-control" placeholder="Name"
                                                    formControlName="workerName">
                                                <label>Name</label>
                                            </div>
                                            <div *ngIf="workersList().controls[i].get('workerName').invalid && workersList().controls[i].get('workerName').touched"
                                                class="small text-danger">
                                                <div
                                                    *ngIf="workersList().controls[i].get('workerName').errors?.required">
                                                    Name is required
                                                </div>
                                            </div>
                                        </div>
                                        <div class="d-flex flex-column row-gap-1">
                                            <div class="form-group floating_form_field mb-0 w-100">
                                                <input type="text" class="form-control" placeholder="Phone Number"
                                                    formControlName="workerPhoneNumber">
                                                <label>Phone Number</label>
                                            </div>
                                            <div *ngIf="workersList().controls[i].get('workerPhoneNumber').invalid && workersList().controls[i].get('workerPhoneNumber').touched"
                                                class="small text-danger">
                                                <div
                                                    *ngIf="workersList().controls[i].get('workerPhoneNumber').errors?.required">
                                                    Name is required
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <a href="javascript:void(0)" class="text-primary font-weight-bold" (click)="addMore()">+ Add
                                another worker</a>
                        </div>
                    </div>
            </div>
        </ngb-accordion>
        <div
            class="pt-3 pt-md-4 pt-lg-5 pt-xl-6 mb-3 mb-md-4 border-top mt-3 mt-md-4 d-flex align-items-center column-gap-12">
            <h3 class="font-weight-semibold mb-0">Mark as Critical</h3>
            <div class="custom-control custom-switch">
                <input type="checkbox" class="custom-control-input" id="markCriticalSwitch"
                    formControlName="markCriticalSwitch">
                <label class="custom-control-label" for="markCriticalSwitch"></label>
            </div>
        </div>
        <div class="d-flex flex-wrap row-gap-3 column-gap-4 column-gap-lg-5 column-gap-xl-6"
            *ngIf="myForm.get('markCriticalSwitch').value === true">
            <div class="custom-control custom-checkbox">
                <input type="checkbox" id="hotWork" name="markCritical" class="custom-control-input">
                <label class="custom-control-label font-weight-semibold" for="hotWork">Hot Work</label>
            </div>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" id="heightWork" name="markCritical" class="custom-control-input">
                <label class="custom-control-label font-weight-semibold" for="heightWork">Height Work</label>
            </div>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" id="confinedSpace" name="markCritical" class="custom-control-input">
                <label class="custom-control-label font-weight-semibold" for="confinedSpace">Confined Space</label>
            </div>
            <div class="custom-control custom-checkbox">
                <input type="checkbox" id="electricalWork" name="markCritical" class="custom-control-input">
                <label class="custom-control-label font-weight-semibold" for="electricalWork">Electrical Work</label>
            </div>
        </div>
        <div
            class="py-3 py-md-4 border-top border-light mt-3 mt-md-4 d-flex align-items-center justify-content-end column-gap-3">
            <button class="btn btn-clear text-muted" type="button">Cancel</button>
            <button class="btn btn-primary" type="submit">Submit</button>
        </div>
    </form>
    <!-- form end -->
</div>